import React, {PureComponent} from 'react';
import {FastField, ErrorMessage} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import messages from '../../../../../res/translations/messages';
import FormGroup from '../FormGroup';
import FormRow from '../FormRow';
import Error from '../../../Error';
import RichEditorField from '../../../rte/RichEditorField';
import {FormattedMessage} from 'react-intl';
import {previousQuestionsSupportingExpressions} from '../../../../services/conditionBuilders';

class Text1Type extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, form, previousPages} = this.props;
        const questions = previousQuestionsSupportingExpressions(previousPages);

        return (
            <>
                <FormRow name={`${name}.text`} label={messages.surveys.form.label.text}>
                    <FastField id={`${name}.text`} name={`${name}.text`} component={RichEditorField} hasImage
                        questions={questions}
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.text`) && get(form.touched, `${name}.text`)})} />
                    <ErrorMessage name={`${name}.text`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <div className="row">
                    <FormGroup name={`${name}.linkUrl`} label={messages.surveys.form.label.linkUrl} size={9}
                        tooltip={messages.surveys.form.tooltip.linkUrl}>
                        <FastField id={`${name}.linkUrl`} name={`${name}.linkUrl`} type="url"
                            className={classNames('form-control',
                                {error: get(form.errors, `${name}.linkUrl`) && get(form.touched, `${name}.linkUrl`)})} />
                        <ErrorMessage name={`${name}.linkUrl`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                    </FormGroup>
                    <FormGroup name={`${name}.linkLabel`} label={messages.surveys.form.label.linkLabel} size={3}
                        tooltip={messages.surveys.form.tooltip.linkLabel}>
                        <FastField id={`${name}.linkLabel`} name={`${name}.linkLabel`} type="text"
                            className={classNames('form-control',
                                {error: get(form.errors, `${name}.linkLabel`) && get(form.touched, `${name}.linkLabel`)})} />
                        <ErrorMessage name={`${name}.linkLabel`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                    </FormGroup>
                </div>
                <div className="row">
                    <FormGroup name={`${name}.redirect`} label={messages.surveys.form.label.redirect} size={3}
                        tooltip={messages.surveys.form.tooltip.redirect}>
                        <FastField name={`${name}.redirect`}>
                            {({field}) => (
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" name={field.name} id={field.name} className="custom-control-input"
                                        checked={field.value} onChange={field.onChange} />
                                    <label className="custom-control-label" htmlFor={field.name}>
                                        <FormattedMessage {...messages.surveys.form.label.redirect} />
                                    </label>
                                </div>
                            )}
                        </FastField>
                    </FormGroup>
                    <FormGroup name={`${name}.redirectTimeout`} label={messages.surveys.form.label.redirectTimeout} size={3}
                        tooltip={messages.surveys.form.tooltip.redirectTimeout}>
                        <FastField id={`${name}.redirectTimeout`} name={`${name}.redirectTimeout`} type="text"
                            className={classNames('form-control',
                                {error: get(form.errors, `${name}.redirectTimeout`) && get(form.touched, `${name}.redirectTimeout`)})} />
                        <ErrorMessage name={`${name}.redirectTimeout`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}
                        </ErrorMessage>
                    </FormGroup>
                </div>
            </>
        );
    }
}

export default Text1Type;
